import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap"
import axiosService from "../../../utils/axios.service";
import {axiosServiceFormData} from "../../../utils/axios.service";
import "../scss/report.scss"
import { Table, Button } from 'antd';
import 'antd/dist/antd.min.css'
import CurrencyInput from 'react-currency-input-field';
import { notifications } from "../../constant/Notify";
import StorageService from "../../../utils/storage.service";
import Loading from "../../customer/Loading";
import PopupInputFile from "./PopupInputFile"

const ReportKtvTvvTargetDetail = (props) => {
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)
    const [weekTotal, setWeekTotal] = useState(0)
    const [showImport, setShowImport] = useState(false)
    const [file, setFile] = useState(null)

    const [note, setNote] = useState('')
    const [table, setTable] = useState([])
    useEffect(() => {
        setTable([...props.table])
    }, [props.table])

    const onChangeNote = (e, d) => {
        setNote(e.target.value)
        let tables = []
        for (let item of props.table) {
            if (item.user_id == d.user_id) {
                item.note = e.target.value
            }
            tables.push(item)
        }
        setTable([...tables])
    }

    const saveEditOrderCode = (e) => {
        if (e.day_id == 0) {
            notifications({ type: 'error', mess: 'Chưa có mục tiêu để thêm ghi chú'});
            return
        }
        const data = {
            "day_id": e.day_id,
            "note": note,
            "taget_week": weekTotal
        }
        axiosService("api/daily-target/day/"+ e.day_id,"POST", data)
            .then((res)=> {
                const response = res.data;
                notifications({ type: 'success', mess: 'Thêm ghi chú thành công'});
            })
        
    }
    
 
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const onChangeMucTieuTuan = (e,d) => {
     
        let data = e.target.value.replaceAll(",", "");
        let tables = []
        for (let item of table) {
            if (item.user_id == d.user_id) {
                item.taget_week = Number(data)
            }
            tables.push(item)
        }
        setTable([...tables])
        setWeekTotal(Number(data))
    }

    var fixed = 'left'
    if (window.innerWidth < 765) {
        fixed = 'unset'
    }
    const columns = [
        {
            title: 'Thời gian',
            // dataIndex: 'date',
            // align: "center",
            fixed: fixed,
            width: 150,
            render: (data) => {
                return (
                    <div>
                        <p className="text6">{data.date}</p>
                        {data.end_week ? <p className="text4"> {'->'} {data.end_week}</p> : null}
                    </div>
                )
            },
        },
        
        {
            title: 'Nhân viên',
            dataIndex: 'user_name',
            // align: "center",
            fixed: fixed,
            width: 150,
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            // dataIndex: 'total_price',
            title: 'Mục tiêu tuần',
            width: 200,
            align: "center",
            render: (data) => {
                return (
                    <> 
                       <p className="text4">
                            <CurrencyInput id={data.user_id} onChange={(e) =>onChangeMucTieuTuan(e, data)} defaultValue={data.taget_week} value={data.taget_week} /><i onClick={(e) => saveEditOrderCode(data)} style={{cursor: 'pointer'}} className="fas fa-save"></i>
                        </p> 
                    </>
               )
            },
        },
        {
            title: 'Ghi chú',
            // align: "center",
            width: 200,
            render: (data) => {
                return (
                    <> 
                       <p className="text4" key={data.user_id}>
                            <textarea key={data.user_id} id={data.user_id} onChange={(e) =>onChangeNote(e, data)} defaultValue={data.note ?? null}  value={data.note ?? null} /><i onClick={(e) => saveEditOrderCode(data)} style={{cursor: 'pointer'}} className="fas fa-save"></i>
                        </p> 
                    </>
               )
            },
        },
        {
            title: 'Nâng cấp Triệt lông Premium',
            // align: "center",
            render: (data) => {
                let total_taget = Number(data.target__1)
                let total_paid = Number(data.paidUpPremium)
                let tiLe = '0'
                if (total_taget > 0 && total_paid > 0) {
                    tiLe = ((total_paid/total_taget)*100).toFixed(1)
                }
               
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text7">Mục tiêu: {data.target__1 == undefined ? 'Ktv chưa thêm' : convertCurrency(total_taget)}</p>
                        <p className="text1">Kết quả: {convertCurrency(total_paid ?? 0)}</p>
                        <p className="text3">Tỉ lệ: {tiLe}%</p>
                    </div>
                )
            },
        },
        {
            title: 'Triệt lông Premium 08 vùng',
            // align: "center",
            render: (data) => {
                let total_taget = Number(data.target__2)
                let total_paid = Number(data.paidPremium08)
                let tiLe = '0'
                if (total_taget > 0 && total_paid > 0) {
                    tiLe = ((total_paid/total_taget)*100).toFixed(1)
                }
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text7">Mục tiêu: {data.target__2 == undefined ? 'Ktv chưa thêm' : convertCurrency(total_taget)}</p>
                        <p className="text1">Kết quả: {convertCurrency(total_paid ?? 0)}</p>
                        <p className="text3">Tỉ lệ: {tiLe}%</p>
                    </div>
                )
            },
        },
        {
            title: 'Triệt lông Premium Fullbody',
            // align: "center",
            render: (data) => {
                let total_taget = Number(data.target__3)
                let total_paid = Number(data.paidPremiumFullbody)
                let tiLe = '0'
                if (total_taget > 0 && total_paid > 0) {
                    tiLe = ((total_paid/total_taget)*100).toFixed(1)
                }
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text7">Mục tiêu: {data.target__3 == undefined ? 'Ktv chưa thêm' : convertCurrency(total_taget)}</p>
                        <p className="text1">Kết quả: {convertCurrency(total_paid ?? 0)}</p>
                        <p className="text3">Tỉ lệ: {tiLe}%</p>
                    </div>
                )
            },
        },
        {
            title: 'Đầu triệt cá nhân',
            // align: "center",
            render: (data) => {
                let total_taget = Number(data.target__4)
                let total_paid = Number(data.paidDauTriet)
                let tiLe = '0'
                if (total_taget > 0 && total_paid > 0) {
                    tiLe = ((total_paid/total_taget)*100).toFixed(1)
                }
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text7">Mục tiêu: {data.target__4 == undefined ? 'Ktv chưa thêm' : convertCurrency(total_taget)}</p>
                        <p className="text1">Kết quả: {convertCurrency(total_paid ?? 0)}</p>
                        <p className="text3">Tỉ lệ: {tiLe}%</p>
                    </div>
                )
            },
        },
        {
            title: 'Cent Upgrade',
            // align: "center",
            render: (data) => {
                let total_taget = Number(data.target__5)
                let total_paid = Number(data.paidCentUpgrade)
                let tiLe = '0'
                if (total_taget > 0 && total_paid > 0) {
                    tiLe = ((total_paid/total_taget)*100).toFixed(1)
                }
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text7">Mục tiêu: {data.target__5 == undefined ? 'Ktv chưa thêm' : convertCurrency(total_taget)}</p>
                        <p className="text1">Kết quả: {convertCurrency(total_paid ?? 0)}</p>
                        <p className="text3">Tỉ lệ: {tiLe}%</p>
                    </div>
                )
            },
        },
        {
            title: 'Triệt lông theo vùng',
            // align: "center",
            with: 150,
            render: (data) => {
                let total_taget = Number(data.target__6)
                let total_paid = Number(data.paidTheoVung)
                let tiLe = '0'
                if (total_taget > 0 && total_paid > 0) {
                    tiLe = ((total_paid/total_taget)*100).toFixed(1)
                }
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text7">Mục tiêu: {data.target__6 == undefined ? 'Ktv chưa thêm' : convertCurrency(total_taget)}</p>
                        <p className="text1">Kết quả: {convertCurrency(total_paid ?? 0)}</p>
                        <p className="text3">Tỉ lệ: {tiLe}%</p>
                    </div>
                )
            },
        },
        {
            title: 'Chăm sóc body',
            // align: "center",
            render: (data) => {
                let total_taget = Number(data.target__7)
                let total_paid = Number(data.paidBody)
                let tiLe = '0'
                if (total_taget > 0 && total_paid > 0) {
                    tiLe = ((total_paid/total_taget)*100).toFixed(1)
                }
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text7">Mục tiêu: {data.target__7 == undefined ? 'Ktv chưa thêm' : convertCurrency(total_taget)}</p>
                        <p className="text1">Kết quả: {convertCurrency(total_paid ?? 0)}</p>
                        <p className="text3">Tỉ lệ: {tiLe}%</p>
                    </div>
                )
            },
        },
        {
            title: 'Chăm sóc Da',
            // align: "center",
            render: (data) => {
                let total_taget = Number(data.target__8)
                let total_paid = Number(data.paidDa)
                let tiLe = '0'
                if (total_taget > 0 && total_paid > 0) {
                    tiLe = ((total_paid/total_taget)*100).toFixed(1)
                }
                return (
                    <div style={{lineHeight: '16px'}}>
                        <p className="text7">Mục tiêu: {data.target__8 == undefined ? 'Ktv chưa thêm' : convertCurrency(total_taget)}</p>
                        <p className="text1">Kết quả: {convertCurrency(total_paid ?? 0)}</p>
                        <p className="text3">Tỉ lệ: {tiLe}%</p>
                    </div>
                )
            },
        },

    ];
    
   
    const handelExportUser = () => {

    }
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    const showImportFile = () => {
        setShowImport(!showImport)
    }
    const importFile = (e) => {
        setFile(e.target.files[0])
    }

    const handleChangeFile= async (e) => {
        if (!file) {
            notifications({ type: 'error', mess: 'Bạn chưa chọn file'});
            return 
        }
       const formData = new FormData();
       formData.append(
            "file",
            file,
            file.name
        );
        let {data} = await axiosServiceFormData("api/daily-target/file", "POST", formData)
        if (data.code == 200) {
            notifications({ type: 'success', mess: 'Thêm mục tiêu thành công'});
            showImportFile()
        } else {
            notifications({ type: 'error', mess: 'Thêm mục tiêu thất bại, kiểm tra lại file'});
        }
       
    }

  
    return (
        <>
            <div style={{ backgroundColor: "white" }} className="p-2">
                
                <div className="border-bottom w-100 pb-2">
                    <Row>
                        <Col xs={6}>
                            <div>
                                Bảng số liệu chi tiết
                            </div>
                        </Col>
                        <Col xs={6}>
                            {/* <input type="file" onChange={(e) => handleChangeFile(e)}/> */}
                            <Button size="middle" type="primary" style={{background: '#4caf50'}}
                                onClick={showImportFile}
                                ><i className="fa-solid fa-file-excel mr-2"></i>Nhập mục tiêu
                            </Button>
                            {/* <Button size="middle" type="primary"
                             onClick={handelExportUser}
                            ><i className="fa-solid fa-file-excel mr-2"></i>Xuất dữ liệu
                            </Button> */}
                        </Col>
                    </Row>
                </div>
                    
                <Table 
                    columns={columns} 
                    dataSource={[...table]}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                    scroll={{ x: columns.length*200, y: 600 }}
                    onChange={handleChange}
                    bordered
                />
            </div>
            <Loading
                show={showLoading}
            ></Loading>
            {showImport ? 
                <PopupInputFile
                    importFile={importFile}
                    close={showImportFile}
                    handleChangeFile={handleChangeFile}
                />
            : null}
        </>
    )
}
export default ReportKtvTvvTargetDetail